import { radii, shadows } from './box';
import colors from './colors';
import { fonts, fontSizes, fontWeights, lineHeights } from './fonts';
import { space } from './layout';
import { breakpoints } from './screens';
import { whiteLabelPalettes } from './whiteLabelColors';

/**
 * This is the the theme object conforming to the SystemUI Theme Spec:
 * (see https://system-ui.com/theme)
 *
 * All other themes should be derived from this theme or its constituent values
 */
export const SolvTheme = {
  colors,
  fonts,
  fontWeights,
  fontSizes,
  lineHeights,
  space,
  radii,
  shadows,
  breakpoints,
} as const;

export type SolvThemeType = typeof SolvTheme;

export const makeWhiteLabeledTheme = (
  paletteName = 'crunchberry' as keyof typeof whiteLabelPalettes,
) => {
  const { palette: whiteLabelPalette } = whiteLabelPalettes[paletteName];
  return {
    colors: {
      /**
       * This colors object comes from the system palette in theme/colors
       * the various crunchberry colors are overwritten here with the corresponding
       * custom palette values for whatever white label palette is chosen.
       *
       * Therefore, any components under this theme will use the white label palette colors
       * wherever they are currently set to use shades of crunchberry
       */
      ...colors,
      crunchberry: whiteLabelPalette.base,
      'crunchberry-dark': whiteLabelPalette['500'],
      'crunchberry-medium': whiteLabelPalette['300'],
      'crunchberry-light': whiteLabelPalette['200'],
      'crunchberry-xlight': whiteLabelPalette['100'],
    },
    fonts,
    fontWeights,
    fontSizes,
    lineHeights,
    space,
    radii,
    shadows,
    breakpoints,
  };
};
